import { useMyDataQuery } from '@/generated/graphql';
import { hasFreecutStudioAccess } from '@/lib/freecut-studio/access';

/** Whether the viewer may open FreeCut Studio; `false` until `myData` loads. */
export const useFreecutStudioAccess = (): boolean => {
  const { data } = useMyDataQuery();
  const me = data?.myData;
  return hasFreecutStudioAccess({
    features: me?.subscription?.plan?.features,
    isAdmin: me?.is_admin,
  });
};
